import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { FormGroup, FormControl } from "@angular/forms";
import { AccountService } from "src/app/dashboard/services/account.service";
import {
  TransactionListFilter,
  Pagination,
  DepositList,
} from "../../../../model/interface.model";
import { GeneralService } from "src/app/dashboard/services/general.service";
import { NbWindowService, NbWindowRef } from "@nebular/theme";

@Component({
  selector: "app-deposit-report",
  templateUrl: "./deposit-report.component.html",
  styleUrls: ["./deposit-report.component.css"],
})
export class DepositReportComponent implements OnInit {
  depositList: DepositList[] = null;
  total_deposits: number = 0;
  math = Math;

  isFilterSet: TransactionListFilter | null = null;
  start_date_error_msg: string = null;
  end_date_error_msg: string = null;
  filterForm: FormGroup;

  // Pagination //
  limits: number[] = [10, 20, 30, 40, 50, 100];
  limitForm: FormGroup;
  current_page: number = 1;
  limit: number = 10;
  total: number = 0;

  @ViewChild("filter") filter: TemplateRef<any>;

  constructor(
    private account: AccountService,
    private general: GeneralService,
    private window: NbWindowService
  ) {}

  ngOnInit() {
    this.limitForm = new FormGroup({
      limitSelected: new FormControl(10),
    });

    this.limitForm.get("limitSelected").valueChanges.subscribe((value) => {
      if (value) {
        this.limit = value;
        if (this.limit * this.current_page > this.total) this.current_page = 1;
        this.getDepositList(this.isFilterSet);
      }
    });

    this.getDepositList();

    this.filterForm = new FormGroup({
      startDate: new FormControl(null),
      endDate: new FormControl(null),
      status: new FormControl(null),
      operation_type: new FormControl(null),
      order_id: new FormControl(null),
      email: new FormControl(null),
      login: new FormControl(null),
      gateway: new FormControl(null),
    });

    //  validate start date on filter
    this.filterForm.get("startDate").valueChanges.subscribe((value) => {
      this.start_date_error_msg = this.general.validateStartDate(
        value,
        this.start_date_error_msg
      );
    });

    //  validate end date on filter
    this.filterForm.get("endDate").valueChanges.subscribe((value) => {
      this.end_date_error_msg = this.general.validateEndDate(
        value,
        this.end_date_error_msg,
        this.filterForm.value.startDate
      );
    });
  }

  getDepositList(
    filter: TransactionListFilter = null,
    fromFilter: boolean = false
  ) {
    let pagination: Pagination = {
      current: this.current_page,
      limit: this.limit,
      filter: filter,
      from_filter: fromFilter,
    };
    this.account.getDepositList(pagination).subscribe((response) => {
      if (response.request_status) {
        this.depositList = response.data.list;
        this.total_deposits = response.data.total_deposits;
        this.total = response.data.total_deposits;
      }
    });
  }

  // Pagination methods //
  Next() {
    if (this.current_page < this.math.ceil(this.total / this.limit)) {
      this.current_page += 1;
      this.getDepositList(this.isFilterSet);
    }
  }
  Previous() {
    if (this.current_page > 1) {
      this.current_page -= 1;
      this.getDepositList(this.isFilterSet);
    }
  }

  First() {
    if (this.current_page !== 1) {
      this.current_page = 1;
      this.getDepositList(this.isFilterSet);
    }
  }
  Last() {
    if (this.current_page !== this.math.ceil(this.total / this.limit)) {
      this.current_page = this.math.ceil(this.total / this.limit);
      this.getDepositList(this.isFilterSet);
    }
  }
  // Pagination methods //

  //  Filter Window
  filterTempWindow: NbWindowRef;
  openFilter() {
    if (this.isFilterSet === null) {
      this.filterForm.reset();
    } else {
      this.filterForm.patchValue({
        startDate:
          this.isFilterSet.start_date === 0 ||
          this.isFilterSet.start_date === null
            ? null
            : new Date(this.isFilterSet.start_date).toISOString().split("T")[0],
        endDate:
          this.isFilterSet.end_date === 0 || this.isFilterSet.end_date === null
            ? null
            : new Date(this.isFilterSet.end_date).toISOString().split("T")[0],
        status: this.isFilterSet.status,
        login: this.isFilterSet.login,
        email: this.isFilterSet.email,
        order_id: this.isFilterSet.order_id,
        operation_type: this.isFilterSet.operation_type,
        gateway: this.isFilterSet.gateway,
      });
    }
    this.filterTempWindow = this.window.open(this.filter, {
      title: "Filter Deposit List",
      closeOnBackdropClick: false,
      closeOnEsc: false,
    });
  }

  clearFilter() {
    this.isFilterSet = null;
    this.resetPagination();
    this.filterForm.reset();
  }

  resetPagination() {
    this.current_page = 1;
    this.limit = 10;
    this.limitForm.setValue({
      limitSelected: 10,
    });
  }

  submitFilter() {
    let isSet = false;
    this.isFilterSet = {
      start_date: null,
      end_date: null,
      status: null,
      order_id: null,
      operation_type: null,
      login: null,
      email: null,
      gateway: null,
    };

    if (
      this.filterForm.value.startDate !== null &&
      this.filterForm.value.startDate !== 0 &&
      this.filterForm.value.startDate !== "" &&
      this.filterForm.value.endDate !== null &&
      this.filterForm.value.endDate !== 0 &&
      this.filterForm.value.endDate !== ""
    ) {
      this.isFilterSet.start_date = new Date(
        this.filterForm.value.startDate
      ).getTime();
      this.isFilterSet.end_date = new Date(
        this.filterForm.value.endDate
      ).getTime();
      isSet = true;
    }

    if (this.filterForm.value.email !== null) {
      this.isFilterSet.email = this.filterForm.value.email;
      isSet = true;
    }

    if (this.filterForm.value.login !== null) {
      this.isFilterSet.login = this.filterForm.value.login;
      isSet = true;
    }

    if (this.filterForm.value.order_id !== null) {
      this.isFilterSet.order_id = this.filterForm.value.order_id;
      isSet = true;
    }

    if (this.filterForm.value.gateway !== null) {
      this.isFilterSet.gateway = this.filterForm.value.gateway;
      isSet = true;
    }

    if (this.filterForm.value.operation_type !== null) {
      this.isFilterSet.operation_type = this.filterForm.value.operation_type;
      isSet = true;
    }

    if (this.filterForm.value.status !== null) {
      this.isFilterSet.status = this.filterForm.value.status;
      isSet = true;
    }

    if (!isSet) {
      this.isFilterSet = null;
    }

    if (isSet) this.resetPagination();
    this.filterTempWindow.close();
  }
}
